import api, { handleApiResponse } from './api';
import { LoginRequest, LoginResponse, User, ApiResponse } from '../types';

export const authService = {
  // Login
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<ApiResponse<LoginResponse>>(
      '/auth/login',
      credentials,
    );
    return handleApiResponse(response);
  },

  // Logout
  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('user');
    // Marks this as a deliberate logout so the route guard's redirect to
    // /login?unauthorized=true (which fires on the same tick, see App.tsx
    // ProtectedRoute) doesn't show a misleading "session expired" banner.
    sessionStorage.setItem('justLoggedOut', '1');
  },

  // Obtener usuario actual
  getCurrentUser(): User | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  // Verificar si está autenticado
  isAuthenticated(): boolean {
    return !!localStorage.getItem('token');
  },

  // Guardar datos de sesión
  saveSession(token: string, user: User, refreshToken?: string): void {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
  },
};
